function debounce(func, wait, immediate) {
  let timeout;
  return function() {
    const args = arguments;
    const later = function() {
      timeout = null;
      if (!immediate) func(...args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func(...args);
  };
};

function isFetchNeeded(itemsContainerEl) {
  const detectOffset = 2000;
  const windowHeight = 'innerHeight' in window ? window.innerHeight : document.documentElement.offsetHeight;

  const { offsetTop, scrollHeight, offsetHeight, clientHeight } = itemsContainerEl;
  const elBottom = offsetTop + Math.max(scrollHeight, offsetHeight, clientHeight);
  const currentY = windowHeight + window.pageYOffset;
  
  return currentY + detectOffset >= elBottom;
}

export default {
  debounce,
  isFetchNeeded,
};